import * as t from "io-ts"
import * as te from "io-ts-extra"

export const TUserDefaults = t.interface({
  airport: t.string,
  season: t.string,
  operator: t.string
})

// in case user is not logged in, all fields will be null
export const TUserInfo = t.interface({
  authStatus: te.optional(t.string),
  userName: te.optional(t.string),
  userDefaults: te.optional(TUserDefaults)
})

export const TUserInfos = t.array(TUserInfo)

export type UserInfo = t.TypeOf<typeof TUserInfo>
export type UserInfos = t.TypeOf<typeof TUserInfos>
